import { Injectable } from "@angular/core";
import { SMQAdminServiceBase } from "./base-classes/smq-admin-service-base";

@Injectable()
export class SMQAdminService extends SMQAdminServiceBase {

} 